import axios from "axios";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../shared/vars";

// ===================================================================================
//  GET BANNERS
// ===================================================================================
export const bannersAreLoading = () => {
	// console.log('banners are now loading')
	return {
		type: "BANNERS_ARE_LOADING"
	};
};

export const bannersHasError = err => {
	// console.log('banners have error')
	return {
		type: "BANNERS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const bannersSuccess = data => {
	// console.log('banners have successfully loaded')
	return {
		type: "BANNERS_SUCCESS",
		data
	};
};

export function getBanners() {
	return dispatch => {
		dispatch(bannersAreLoading());

		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };

		return axios
			.get(REACT_APP_API_URL + "banners", { headers: AUTH_HEADER })
			.then(response => {
				dispatch(bannersSuccess(response));
			})
			.catch(err => {
				console.log("getBanners error:", err.response);
				dispatch(bannersHasError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/banners.js